import http from "./HttpService";

var endpoint = `/reporting/analytics/events/`;

const headers = {};

const getRace = async (
  yearFilter = "-1",
  startDate,
  endDate,
  filterId,
  filterType = "venue",
  percentage = false,
) => {
  const { data } = await http.get(
    `${endpoint}participant/race/${yearFilter}/${filterId}?startDate=${startDate}&endDate=${endDate}&filterType=${filterType}`,
  );
  return { data };
};

const getGender = async (
  yearFilter = "-1",
  startDate,
  endDate,
  filterId,
  filterType = "venue",
  percentage = false,
) => {
  const { data } = await http.get(
    `${endpoint}participant/gender/${yearFilter}/${filterId}?startDate=${startDate}&endDate=${endDate}&filterType=${filterType}`,
  );
  return { data };
};

const getDisability = async (
  yearFilter = "-1",
  startDate,
  endDate,
  filterId,
  filterType = "venue",
  percentage = false,
) => {
  const { data } = await http.get(
    `${endpoint}participant/disability/${yearFilter}/${filterId}?startDate=${startDate}&endDate=${endDate}&filterType=${filterType}`,
  );

  return { data };
};

const getAge = async (
  yearFilter = "-1",
  startDate,
  endDate,
  filterId,
  filterType = "venue",
  percentage = true,
) => {
  const { data } = await http.get(
    `${endpoint}participant/age-group/${yearFilter}/${filterId}?startDate=${startDate}&endDate=${endDate}&filterType=${filterType}`,
  );
  return { data };
};

const getParticipationType = async (
  yearFilter = "-1",
  startDate,
  endDate,
  filterId,
  filterType = "venue",
  percentage = true,
) => {
  const { data } = await http.get(
    `${endpoint}participant/type/${yearFilter}/${filterId}?startDate=${startDate}&endDate=${endDate}&filterType=${filterType}`,
  );
  return { data };
};

const getProvincialDistribution = async (yearFilter = "-1",startDate, endDate, filterId, filterType = "venue", percentage = true) => {
  const {data} = await http.get(`${endpoint}distribution/provincial/${yearFilter}/${filterId}?startDate=${startDate}&endDate=${endDate}&filterType=${filterType}`);
  return {data};
};

const getMunicipalDistribution = async (yearFilter = "-1",startDate, endDate, filterId, filterType = "venue", percentage = true) => {
  const {data} = await http.get(`${endpoint}distribution/municipal/${yearFilter}/${filterId}?startDate=${startDate}&endDate=${endDate}&filterType=${filterType}`);
  return {data};
};

const getLocalMunicipalDistribution = async (yearFilter = "-1",startDate, endDate, filterId, filterType = "venue", district=false, percentage = true) => {
  const {data} = await http.get(`${endpoint}distribution/municipal/${yearFilter}/${filterId}?startDate=${startDate}&endDate=${endDate}&filterType=${filterType}&district=${district}`);
  return data;
};

const getProvincialParticipation = async (yearFilter = "-1",startDate, endDate, filterId, filterType = "venue", percentage = true) => {
  const {data} = await http.get(`${endpoint}participant/origin/provincial/${yearFilter}/${filterId}?startDate=${startDate}&endDate=${endDate}&filterType=${filterType}`);
  return data;
};

const getProvincialParticipationCount = async (year, filterId, filterType = "venue", percentage = false) => {
  const response = await http.get(`${endpoint}participant/origin/provincial/${year}/${filterId}?filterType=${filterType}`);
  return response;
};

const getMunicipalParticipation = async (yearFilter = "-1",startDate, endDate, filterId, filterType = "venue", percentage = true) => {
  const {data} = await http.get(`${endpoint}participant/origin/municipal/${yearFilter}/${filterId}?startDate=${startDate}&endDate=${endDate}&filterType=${filterType}`);
  return {data};
};

const getYearRange = async (isLocation) => {
  const response = isLocation ? await http.get(`${endpoint}location/year-range`)
    : await http.get(`${endpoint}year-range`);
  return response;
};

const getEvents = async (year, isLocation) => {
  const response = isLocation ? await http.get(`${endpoint}location/list/${year}`)
    : await http.get(`${endpoint}${year}`);
  return response;
}; 

const getProvinces = async () => {
  const response = await http.get(`${endpoint}location/provinces`);
    return response;
};

const getProvinceEvents = async (reportYear) => {
  const response = await http.get(`${endpoint}location/provinces/${reportYear}`);
    return response;
};

const getProvinceDistrictsEvents = async (reportYear,provinceId) => {
  const response = await http.get(`${endpoint}location/districts/${reportYear}?provinceId=${provinceId}`);
     return response;
};

const getEventLocations = async (year, provinceId) => {
  const response = await http.get(`${endpoint}location/marker/${year}/${provinceId}`);
  return response;
};

const getEventLocationsList = async (year, province, district, offset = 0, limit=10000) => {
  const response = await http.get(`${endpoint}location/list/${year}?province=${province}&district=${district}&offset=${offset}&limit=${limit}`);
  return response;
  };

const getEventsByRange = async (
  yearFilter = -1,
  startDate,
  endDate,
  filterId = "-1",
) => {
  const { data } = await http.get(
    `${endpoint}${yearFilter}?startDate=${startDate}&endDate=${endDate}`,
  );
  return data;
};


/* eslint-disable import/no-anonymous-default-export */
export default {
  getRace,
  getParticipationType,
  getGender,
  getDisability,
  getAge,
  getProvincialDistribution,
  getMunicipalDistribution,
  getLocalMunicipalDistribution,
  getProvincialParticipation,
  getMunicipalParticipation,
  getYearRange,
  getEvents,
  getProvincialParticipationCount,
  getProvinces,
  getEventLocations,
  getProvinceEvents,
  getProvinceDistrictsEvents,
  getEventLocationsList,
  getEventsByRange,
};
